<template>
  <div class="wrapper">
    <div class="mid">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" :finished-text="list.length?'没有更多了':''" @load="loadMore">
          <div class="no" v-if="list.length == 0">
            <img src="./../../assets/images/kb.png" alt="">
            <div>暂无数据</div>
          </div>
          <div class="content" v-for="(item,index) in list" :key="index">
            <van-row class="box" @click.native="godetail(item.nbr,item.state)">
              <van-row class="goodlist" type="flex">
                <van-row class="img">
                  <img :src="item.commodity_logo" alt="">
                  <van-row class="" v-if="item.state != 1">已下架</van-row>
                </van-row>
                <van-row class="goodinfo">
                  <van-row class="name more-h" style="word-break: break-all;-webkit-line-clamp: 3;" >{{item.commodity_name}}</van-row>
                  <van-row type="flex" justify="space-between">
                    <van-col>
                      <span>
                        <i class="money">¥</i>{{item.sell_price}}
                      </span>
                      <span class="text">¥{{item.old_price}}</span>
                    </van-col>
                    <van-col @click.native.stop="del(index)"><img src="./../../assets/images/icon_delete.svg" alt="">
                    </van-col>
                  </van-row>
                </van-row>
              </van-row>
            </van-row>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
  import weChatShareApi from "../../assets/js/weChatShare";
  export default {
    components: {},
    props: {},
    mixins: [weChatShareApi],
    data() {
      return {
        isLoading: false,
        loading: false,
        finished: false,
        pageIndex: 0,
        totalRows: 0,
        numPerPage: 10,
        list: '',
      }
    },
    watch: {},
    methods: {
      onRefresh() {
        this.pageIndex = 0;
        this.isLoading=true;
        this.finished = false;
        this.getData([]);
      },
      loadMore(){
        if(this.finished){
          return false
        }
        if(this.totalRows>(this.pageIndex+1) * this.numPerPage){
          this.loading = true;
          this.pageIndex++
          this.getData(this.list);
        }
      },
      /**
       * 去详情
       * @param index
       */
      godetail(nbr,state) {
        if(state!='1'){
          return this.$toast({
            message: '该商品已下架',
            duration: 2000
          });
        }
        this.$router.push({path: 'listdetail', query: {nbr: nbr,supNbr:this.userInfo.nbr}});
      },
      del(index) {
        let arr = [];
        arr.push(this.list[index].nbr)
        
        let toast = this.$toast.loading({
          mask: true,
          duration: 0,
        });
        
        this.$commonPost({
          'jydm': 'flow_10000',
          'flow_10000': {
            'sub_flow': 'flow_10013',
            user_nbr: this.userInfo.nbr,
            commodity: {
              nbr: arr
            }
          }
        }).then(response => {
          toast.clear()
          this.$toast({
            message: '取消收藏商品成功',
            duration: 2000
          });
          this.getData([])
        }).catch( err => {
          toast.clear()
          this.$toast({
            message: err.message,
            duration: 2000
          });
        })
      },
      getData(oldList) {
        this.loading = true; //手动控制上啦正在加载，防止多次请求
        this.$commonPost({
          'jydm': 'flow_10014',
          'flow_10014': {
            user_nbr: this.userInfo.nbr,
            page_index: this.pageIndex*this.numPerPage,
            num_per_page: this.numPerPage,
          }
        }).then(response => {
          let arr = [];
          if (response.total_rows > 0) {
            if (response.commodityList.length > 0) {
              arr = response.commodityList;
            } else {
              arr.push(response.commodityList);
            }
          }
          this.list = oldList.concat(arr);
          this.totalRows = response.total_rows
          this.loading = false;
          this.isLoading = false;
          if (response.total_rows == this.list.length) {
            this.finished = true;
          }
        }).catch( err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        })
      },
      initPage(){
        this.getData([])
      }
    },
    created() {
      let option = {
        title: '有米@'+this.userInfo.name+'的店铺',
        desc: "欢迎光临我的店铺",
        link: location.origin + "/?supNbr=" + this.userInfo.nbr,
        images: this.userInfo.imgUrl,
      };
      this.weChatShare(option)
    },
    activated(){
      document.title = '收藏';
      this.pageIndex = 0
      this.initPage()
    },
    mounted() {
      
    }
  }
</script>
<style scoped lang='stylus'>
  .mid >>> .van-pull-refresh__track {
    min-height: 100vh;
  }
  
  .mid >>> .van-list__finished-text {
    // background: #FFFFFF;
  }
  
  .mid >>> .no {
    margin: 0 auto 0;
    padding-top: 2rem;
    text-align: center;
    img {
    width: 3.46rem;
    height: 2.1rem;
    margin-bottom: 0.1rem;
  }
  }
</style>
<style scoped lang='less'>
.wrapper .line {
  width: 100%;
  height: 0.18rem;
  background: #F5F5F5;
  margin-left: -0.26rem;
  padding-right: 0.51rem;
}
.money{
  font-size: 0.24rem;
  font-weight: bold;
  color: #E52B25;
  line-height: 0.33rem;
}
  .wrapper {
    width: 100%;
    background: #F5F5F5;
    min-height: 100vh;
  }
  
  .mid {
    box-sizing: border-box;
  .content {
    background: #FFFFFF;
    padding: 0.28rem 0.24rem 0;
  }
  .box {
    box-sizing: border-box;
  .goodlist {
    margin-bottom: 0.28rem;
  .img {
    position: relative;
    border-radius:0.08rem;
    width: 2.28rem;
    height: 2.28rem;
    overflow: hidden;
    background: #f8f8f8;
  img {
    width: 2.28rem;
    height: 2.28rem;
    object-fit: cover;
  }
  .van-row {
    width: 100%;
    text-align: center;
    line-height: 0.54rem;
    height: 0.54rem;
    position: absolute;
    border-radius: 0 0 0.12rem 0.12rem;
    bottom: 0;
    opacity: 0.7;
    font-size: 0.24rem;
    color: #BBBBBB;
    background-image: linear-gradient(-180deg, #000000 0%, #000000 100%);
  }
  }
  .goodinfo {
    flex: 1;
    margin-left: 0.24rem;
    font-size: 0.24rem;
    color: #999999;
    line-height: 0.34rem;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    .text{
      text-decoration: line-through;
      font-size: 0.24rem;
      color: #999999;
      font-weight: normal;
}
  .name {
    color: #333333;
    font-size: 0.24rem;
  }
  img {
    height: 0.32rem;
    width: 0.32rem;
  }
  span {
    color: #E52B25;
    font-size: 0.32rem;
    font-weight: bold;
  }
  }
  .goodinfo:after {
    display: none;
  }
  }
  }
  }

</style>



// WEBPACK FOOTER //
// src/components/information/collect.vue